module.exports = __webpack_public_path__ + "static/img/5_IMG_20160224_162307.10220480.jpg";